import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
// Layout
import { LayoutConfigService } from '@core/_base/layout';
// Object-Path
import objectPath from 'object-path';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { TbTipoCambioService } from '~services/maestros-sync/tbTipoCambio.service';
import { SearchTbTipoCambioDto } from '~models/maestros-sync/SearchTbTipoCambioDto';
import { TbTipoCambio } from '~models/maestros-sync/TbTipoCambio';

@Component({
	selector: 'kt-footer',
	templateUrl: './footer.component.html',
	host: {
		class: 'kt-footer',
	},
	encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
	private readonly _layoutConfigService = inject(LayoutConfigService);
	private readonly _tbTipoCambioService = inject(TbTipoCambioService);
	private readonly _datepipe = inject(DatePipe);

	today: number = Date.now();
	fluid!: boolean;
	searchTbTipoCambioDto!: SearchTbTipoCambioDto;
	tbTipoCambio$!: Observable<TbTipoCambio>;

	ngOnInit(): void {
		const config = this._layoutConfigService.getConfig();

		this.searchTbTipoCambioDto = {
			codMoneda: 'USD',
			codMonedaConversion: 'PEN',
			fchCambio: this._datepipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ss.SSS') as string,
		};
		this.tbTipoCambio$ = this._tbTipoCambioService.findLatestByMonedaAndFchCambio(
			this.searchTbTipoCambioDto
		);

		// footer width fluid
		this.fluid = objectPath.get(config, 'footer.self.width') === 'fluid';
	}
}
